<template>
    <div class="header-navbar">
        <router-link :to="'/home'" class="navbar-item" :class="{active : navbar == 0}">
            <i class="iconfont icon-gongchang"></i>
            <span>{{$t('menu0')}}</span>
        </router-link>
        <router-link :to="'/layout'" class="navbar-item" :class="{active : navbar == 1}">
            <i class="iconfont icon-baocunbuju"></i>
            <span>{{$t('menu1')}}</span>
        </router-link>
        <router-link :to="'/production/target'" class="navbar-item" :class="{active : navbar == 2 || navbar == 3}">
            <i class="iconfont icon-shengchanguanli1"></i>
            <span>{{$t('menu2')}}</span>
        </router-link>
        <router-link :to="'/analysis/oee'" class="navbar-item" :class="{active : navbar == 4 || navbar == 5 || navbar == 6}">
            <i class="iconfont icon-fenxi"></i>
            <span>{{$t('menu3')}}</span>
        </router-link>
        <router-link :to="'/alarm'" class="navbar-item" :class="{active : navbar == 7}">
            <i class="iconfont icon-baojing1"></i>
            <span>{{$t('menu4')}}</span>
        </router-link>
        <router-link :to="'/users'" class="navbar-item" :class="{active : navbar == 8}">
            <i class="iconfont icon-erji-yonghuguanli"></i>
            <span>{{$t('menu5')}}</span>
        </router-link>
        <router-link :to="'/system/factory'" class="navbar-item" :class="{active : navbar == 9 || navbar == 10 || navbar == 11 || navbar == 12 || navbar == 13}">
            <i class="iconfont icon-peizhi2"></i>
            <span>{{$t('menu6')}}</span>
        </router-link>
    </div>
</template>
<script>
export default {
    computed: {
        navbar() {
            return this.$store.state.navbar;
        }
    }
};
</script>
<style lang="less">
.header-navbar {
    position: fixed;
    left: 0;
    top: 45px;
    z-index: 99;
    width: 95px;
    height: 100%;
    background-color: #f2f2f2;
    box-shadow: 0 5px 5px #666;
    .navbar-item {
        display: flex;
        height: 90px;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        border-bottom: 1px solid #e4e4e4;
        span,
        i {
            color: #a4a4a4;
        }
        &:hover {
            background-color: white;
            span,
            i {
                color: #038390;
            }
        }
        &.active {
            background-color: white;
            span,
            i {
                color: #038390;
            }
        }
    }
    .iconfont {
        font-size: 30px;
    }
}
</style>





// WEBPACK FOOTER //
// src/views/main_components/navbar.vue